import type { StudentChannel } from '@/apis/experience/student-login';

import styles from './index.module.scss';

type Props = {
  readonly channels: StudentChannel[];
  readonly onPick: (channel: StudentChannel) => void;
  readonly isSubmitting?: boolean;
};

/**
 * Presents the masked contact channels resolved from a student's number and lets
 * them choose where the password-reset code should be sent. Only masked values
 * are shown; the underlying contact value is passed back via {@link onPick}.
 */
const ChannelPicker = ({ channels, onPick, isSubmitting }: Props) => (
  <div className={styles.picker}>
    {channels.map((channel) => (
      <button
        key={`${channel.type}:${channel.masked}`}
        type="button"
        className={styles.channel}
        disabled={isSubmitting}
        onClick={() => {
          onPick(channel);
        }}
      >
        {channel.masked}
      </button>
    ))}
  </div>
);

export default ChannelPicker;
